import BlankNotice from '@components/blank/BlankNotice';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';

import { BoardCardList } from '../BoardCard';
import BoardCardSkeletons from '../BoardCard/BoardCardSkeletons';
import useNotices from './hooks/useNotices';
import NoticeItem from './NoticeItem';

function NoticeList() {
    const {
        notices, fetchNextPage, isBlank, isPending, isFetchingNextPage,
    } = useNotices();
    return (
        <BoardCardList as='main' fullWidth spacing={4}
            align='center' >
            {isBlank && (
                <BlankNotice/>
            )}
            {notices?.map((notice) => (
                <NoticeItem notice={notice}
                    key={notice.id} />
            ))}
            {(isPending || isFetchingNextPage) && (
                <BoardCardSkeletons count={isPending ? 3 : 1} />
            )}
            <InfinityScrollTrigger trigger={fetchNextPage}/>
        </BoardCardList>
    );
}

export default NoticeList;
